import axios from 'axios';
export default async function initCampaignIdSFDC(campaignId, campaignStatus) {
	const
		language = document.documentElement.getAttribute('data-lang') || document.documentElement.getAttribute('lang') || 'en-US',
		campaignData = {
			CampaignId: campaignId,
			CampaignStatus: campaignStatus,
			Language: language
		}
	await axios.post('/api/sfdc/tracking/campaign', campaignData)
		.then(_response => {
		})
		.catch(error => {
			console.warn(error);
		})
}
